export default "__VITE_ASSET__COGu6t_O__"